// import {ClickControllerAdapter} from './ClickController';
import {CardControllerAdapter} from './CardController';
import {CanvasInitAdapter} from './CanvasInit';
import {PreloadController} from './Preloader';
import {PreloadPicsController} from './Preloadpics';
import {MenuController} from './Menu';
import {HelperBlockAdapter} from './HelperBlock';
import {DragControllerAdapter} from './DragController';
import {InitPointsPositioningAdapter} from './initPointsPositioning';

module.exports.InitPointsPositioning = () => {
    const InitPointsPositioning = new InitPointsPositioningAdapter();
    return InitPointsPositioning;
};

module.exports.ClickController = () => {
    const ClickController = new CardControllerAdapter();
    return ClickController;
};

module.exports.CanvasInit = () => {
    const CanvasInit = new CanvasInitAdapter();
    return CanvasInit;
};

module.exports.Preloader = () => {
    const Preloader = new PreloadController();
    return Preloader;
};

module.exports.PreloadPics = () => {
    const PreloadPics = new PreloadPicsController();
    return PreloadPics;
};

module.exports.Menu = () => {
    const Menu = new MenuController();
    return Menu;
};

module.exports.HelperBlock = () => {
    const HelperBlock = new HelperBlockAdapter();
    return HelperBlock;
};

module.exports.DragController = () => {
    const DragController = new DragControllerAdapter();
    return DragController;
};
